import { useCallback } from 'react';

/**
 * The hooks allows you to scroll to a specific node
 * @param containerNodeId Container node ID which contain can be scrolled
 * @param offsetHeight offset for the scrolling
 */
const useScrollToModule = (containerNodeId: string, offsetHeight?: number) => {


  const handleScroll = useCallback(
    /**
   * @param itemNodeId ID of child Node
   */  
    (itemNodeId: string) => {
      const wrapperNode = document.getElementById(containerNodeId);
      if(wrapperNode) {
        const elem = document.getElementById(itemNodeId);
        if (elem) {
          const tocItemPos = elem.offsetTop - wrapperNode.offsetTop - (offsetHeight || 0);
          wrapperNode.scrollTo({ top: tocItemPos, behavior: 'smooth' });
        }
      }
   
    }, [containerNodeId, offsetHeight]);

  return handleScroll; 
};

export default useScrollToModule;